module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/256.c86870c4.png";